export const messagesTranslations = {
  en: {
    'messages.backToMessages': 'Back to Messages',
    'messages.markAsRead': 'Mark as Read',
    'messages.title': 'Messages',
    'messages.count': '{count} message',
    'messages.count_plural': '{count} messages',
    'messages.markAllRead': 'Mark All Read',
    'messages.filter': 'Filter',
    'messages.allMerchants': 'All Merchants',
    'messages.showUnread': 'Show Unread Only',
    'messages.searchPlaceholder': 'Search messages...',
    'messages.tabs.all': 'All',
    'messages.tabs.unread': 'Unread',
    'messages.tabs.announcements': 'Announcements',
    'messages.tabs.conversations': 'Conversations',
    'messages.tabs.following': 'Following',
    'messages.tabs.blocked': 'Blocked',
    'messages.loading': 'Loading messages...',
    'messages.empty': 'No messages',
    'messages.emptySearch': 'No messages match your search',
    'messages.emptyUnread': 'No unread messages',
    'messages.emptyAnnouncements': 'No announcements yet',
    'messages.emptyConversations': 'No conversations yet',
    'messages.emptyDefault': 'No messages yet',
    'messages.announcement': 'Announcement',
    'messages.conversation': 'Conversation',
    'messages.new': 'New',
    'messages.toast.allRead': 'All messages marked as read',
    'messages.toast.errorMarkingRead': 'Failed to mark all messages as read',
  },
  es: {
    'messages.backToMessages': 'Volver a Mensajes',
    'messages.markAsRead': 'Marcar como leído',
    'messages.title': 'Mensajes',
    'messages.count': '{count} mensaje',
    'messages.count_plural': '{count} mensajes',
    'messages.markAllRead': 'Marcar todo como leído',
    'messages.filter': 'Filtrar',
    'messages.allMerchants': 'Todos los Comerciantes',
    'messages.showUnread': 'Mostrar solo no leídos',
    'messages.searchPlaceholder': 'Buscar mensajes...',
    'messages.tabs.all': 'Todos',
    'messages.tabs.unread': 'No leídos',
    'messages.tabs.announcements': 'Anuncios',
    'messages.tabs.conversations': 'Conversaciones',
    'messages.tabs.following': 'Siguiendo',
    'messages.tabs.blocked': 'Bloqueados',
    'messages.loading': 'Cargando mensajes...',
    'messages.empty': 'No hay mensajes',
    'messages.emptySearch': 'Ningún mensaje coincide con tu búsqueda',
    'messages.emptyUnread': 'No hay mensajes no leídos',
    'messages.emptyAnnouncements': 'Aún no hay anuncios',
    'messages.emptyConversations': 'Aún no hay conversaciones',
    'messages.emptyDefault': 'Aún no hay mensajes',
    'messages.announcement': 'Anuncio',
    'messages.conversation': 'Conversación',
    'messages.new': 'Nuevo',
    'messages.toast.allRead': 'Todos los mensajes marcados como leídos',
    'messages.toast.errorMarkingRead': 'Error al marcar todos los mensajes como leídos',
  },
  fr: {
    'messages.backToMessages': 'Retour aux messages',
    'messages.markAsRead': 'Marquer comme lu',
    'messages.title': 'Messages',
    'messages.count': '{count} message',
    'messages.count_plural': '{count} messages',
    'messages.markAllRead': 'Tout marquer comme lu',
    'messages.filter': 'Filtrer',
    'messages.allMerchants': 'Tous les marchands',
    'messages.showUnread': 'Afficher uniquement les non lus',
    'messages.searchPlaceholder': 'Rechercher des messages...',
    'messages.tabs.all': 'Tous',
    'messages.tabs.unread': 'Non lus',
    'messages.tabs.announcements': 'Annonces',
    'messages.tabs.conversations': 'Conversations',
    'messages.tabs.following': 'Abonnements',
    'messages.tabs.blocked': 'Bloqués',
    'messages.loading': 'Chargement des messages...',
    'messages.empty': 'Aucun message',
    'messages.emptySearch': 'Aucun message ne correspond à votre recherche',
    'messages.emptyUnread': 'Aucun message non lu',
    'messages.emptyAnnouncements': 'Aucune annonce pour le moment',
    'messages.emptyConversations': 'Aucune conversation pour le moment',
    'messages.emptyDefault': 'Aucun message pour le moment',
    'messages.announcement': 'Annonce',
    'messages.conversation': 'Conversation',
    'messages.new': 'Nouveau',
    'messages.toast.allRead': 'Tous les messages marqués comme lus',
    'messages.toast.errorMarkingRead': 'Échec du marquage de tous les messages comme lus',
  },
  sq: {
    'messages.backToMessages': 'Kthehu te Mesazhet',
    'messages.markAsRead': 'Shëno si të Lexuar',
    'messages.title': 'Mesazhet',
    'messages.count': '{count} mesazh',
    'messages.count_plural': '{count} mesazhe',
    'messages.markAllRead': 'Shëno të Gjitha si të Lexuara',
    'messages.filter': 'Filtro',
    'messages.allMerchants': 'Të Gjithë Tregtarët',
    'messages.showUnread': 'Shfaq Vetëm të Palexuarat',
    'messages.searchPlaceholder': 'Kërkoni mesazhe...',
    'messages.tabs.all': 'Të gjitha',
    'messages.tabs.unread': 'Të palexuara',
    'messages.tabs.announcements': 'Njoftimet',
    'messages.tabs.conversations': 'Bisedat',
    'messages.tabs.following': 'Duke ndjekur',
    'messages.tabs.blocked': 'Të bllokuara',
    'messages.loading': 'Duke ngarkuar mesazhet...',
    'messages.empty': 'Nuk ka mesazhe',
    'messages.emptySearch': 'Asnjë mesazh nuk përputhet me kërkimin tuaj',
    'messages.emptyUnread': 'Nuk ka mesazhe të palexuara',
    'messages.emptyAnnouncements': 'Ende nuk ka njoftime',
    'messages.emptyConversations': 'Ende nuk ka biseda',
    'messages.emptyDefault': 'Ende nuk ka mesazhe',
    'messages.announcement': 'Njoftim',
    'messages.conversation': 'Bisedë',
    'messages.new': 'E re',
    'messages.toast.allRead': 'Të gjitha mesazhet u shënuan si të lexuara',
    'messages.toast.errorMarkingRead': 'Dështoi shënimi i të gjitha mesazheve si të lexuara',
  },
  ru: {
    'messages.backToMessages': 'Вернуться к сообщениям',
    'messages.markAsRead': 'Отметить как прочитанное',
    'messages.title': 'Сообщения',
    'messages.count': '{count} сообщение',
    'messages.count_plural': '{count} сообщений',
    'messages.markAllRead': 'Отметить все как прочитанные',
    'messages.filter': 'Фильтр',
    'messages.allMerchants': 'Все продавцы',
    'messages.showUnread': 'Показать только непрочитанные',
    'messages.searchPlaceholder': 'Поиск сообщений...',
    'messages.tabs.all': 'Все',
    'messages.tabs.unread': 'Непрочитанные',
    'messages.tabs.announcements': 'Объявления',
    'messages.tabs.conversations': 'Разговоры',
    'messages.tabs.following': 'Подписки',
    'messages.tabs.blocked': 'Заблокированные',
    'messages.loading': 'Загрузка сообщений...',
    'messages.empty': 'Нет сообщений',
    'messages.emptySearch': 'Нет сообщений, соответствующих вашему поиску',
    'messages.emptyUnread': 'Нет непрочитанных сообщений',
    'messages.emptyAnnouncements': 'Пока нет объявлений',
    'messages.emptyConversations': 'Пока нет разговоров',
    'messages.emptyDefault': 'Пока нет сообщений',
    'messages.announcement': 'Объявление',
    'messages.conversation': 'Разговор',
    'messages.new': 'Новое',
    'messages.toast.allRead': 'Все сообщения отмечены как прочитанные',
    'messages.toast.errorMarkingRead': 'Не удалось отметить все сообщения как прочитанные',
  },
  pt: {
    'messages.backToMessages': 'Voltar para Mensagens',
    'messages.markAsRead': 'Marcar como Lido',
    'messages.title': 'Mensagens',
    'messages.count': '{count} mensagem',
    'messages.count_plural': '{count} mensagens',
    'messages.markAllRead': 'Marcar Todas como Lidas',
    'messages.filter': 'Filtrar',
    'messages.allMerchants': 'Todos os Comerciantes',
    'messages.showUnread': 'Mostrar Apenas Não Lidas',
    'messages.searchPlaceholder': 'Buscar mensagens...',
    'messages.tabs.all': 'Todas',
    'messages.tabs.unread': 'Não Lidas',
    'messages.tabs.announcements': 'Anúncios',
    'messages.tabs.conversations': 'Conversas',
    'messages.tabs.following': 'Seguindo',
    'messages.tabs.blocked': 'Bloqueados',
    'messages.loading': 'Carregando mensagens...',
    'messages.empty': 'Nenhuma mensagem',
    'messages.emptySearch': 'Nenhuma mensagem corresponde à sua busca',
    'messages.emptyUnread': 'Nenhuma mensagem não lida',
    'messages.emptyAnnouncements': 'Ainda não há anúncios',
    'messages.emptyConversations': 'Ainda não há conversas',
    'messages.emptyDefault': 'Ainda não há mensagens',
    'messages.announcement': 'Anúncio',
    'messages.conversation': 'Conversa',
    'messages.new': 'Nova',
    'messages.toast.allRead': 'Todas as mensagens marcadas como lidas',
    'messages.toast.errorMarkingRead': 'Falha ao marcar todas as mensagens como lidas',
  },
  el: {
    'messages.backToMessages': 'Επιστροφή στα Μηνύματα',
    'messages.markAsRead': 'Σήμανση ως Διαβασμένο',
    'messages.title': 'Μηνύματα',
    'messages.count': '{count} μήνυμα',
    'messages.count_plural': '{count} μηνύματα',
    'messages.markAllRead': 'Σήμανση Όλων ως Διαβασμένα',
    'messages.filter': 'Φίλτρο',
    'messages.allMerchants': 'Όλοι οι Έμποροι',
    'messages.showUnread': 'Εμφάνιση Μόνο Μη Διαβασμένων',
    'messages.searchPlaceholder': 'Αναζήτηση μηνυμάτων...',
    'messages.tabs.all': 'Όλα',
    'messages.tabs.unread': 'Μη διαβασμένα',
    'messages.tabs.announcements': 'Ανακοινώσεις',
    'messages.tabs.conversations': 'Συνομιλίες',
    'messages.tabs.following': 'Ακολουθώ',
    'messages.tabs.blocked': 'Αποκλεισμένα',
    'messages.loading': 'Φόρτωση μηνυμάτων...',
    'messages.empty': 'Δεν υπάρχουν μηνύματα',
    'messages.emptySearch': 'Κανένα μήνυμα δεν ταιριάζει με την αναζήτησή σας',
    'messages.emptyUnread': 'Δεν υπάρχουν μη διαβασμένα μηνύματα',
    'messages.emptyAnnouncements': 'Δεν υπάρχουν ακόμα ανακοινώσεις',
    'messages.emptyConversations': 'Δεν υπάρχουν ακόμα συνομιλίες',
    'messages.emptyDefault': 'Δεν υπάρχουν ακόμα μηνύματα',
    'messages.announcement': 'Ανακοίνωση',
    'messages.conversation': 'Συνομιλία',
    'messages.new': 'Νέο',
    'messages.toast.allRead': 'Όλα τα μηνύματα σημάνθηκαν ως διαβασμένα',
    'messages.toast.errorMarkingRead': 'Αποτυχία σήμανσης όλων των μηνυμάτων ως διαβασμένα',
  },
  de: {
    'messages.backToMessages': 'Zurück zu Nachrichten',
    'messages.markAsRead': 'Als gelesen markieren',
    'messages.title': 'Nachrichten',
    'messages.count': '{count} Nachricht',
    'messages.count_plural': '{count} Nachrichten',
    'messages.markAllRead': 'Alle als gelesen markieren',
    'messages.filter': 'Filtern',
    'messages.allMerchants': 'Alle Händler',
    'messages.showUnread': 'Nur Ungelesene anzeigen',
    'messages.searchPlaceholder': 'Nachrichten suchen...',
    'messages.tabs.all': 'Alle',
    'messages.tabs.unread': 'Ungelesen',
    'messages.tabs.announcements': 'Ankündigungen',
    'messages.tabs.conversations': 'Unterhaltungen',
    'messages.tabs.following': 'Folgen',
    'messages.tabs.blocked': 'Blockiert',
    'messages.loading': 'Nachrichten werden geladen...',
    'messages.empty': 'Keine Nachrichten',
    'messages.emptySearch': 'Keine Nachrichten entsprechen Ihrer Suche',
    'messages.emptyUnread': 'Keine ungelesenen Nachrichten',
    'messages.emptyAnnouncements': 'Noch keine Ankündigungen',
    'messages.emptyConversations': 'Noch keine Unterhaltungen',
    'messages.emptyDefault': 'Noch keine Nachrichten',
    'messages.announcement': 'Ankündigung',
    'messages.conversation': 'Unterhaltung',
    'messages.new': 'Neu',
    'messages.toast.allRead': 'Alle Nachrichten als gelesen markiert',
    'messages.toast.errorMarkingRead': 'Fehler beim Markieren aller Nachrichten als gelesen',
  },
  ro: {
    'messages.backToMessages': 'Înapoi la Mesaje',
    'messages.markAsRead': 'Marchează ca Citit',
    'messages.title': 'Mesaje',
    'messages.count': '{count} mesaj',
    'messages.count_plural': '{count} mesaje',
    'messages.markAllRead': 'Marchează Totul ca Citit',
    'messages.filter': 'Filtrează',
    'messages.allMerchants': 'Toți Comercianții',
    'messages.showUnread': 'Afișează Doar Necitite',
    'messages.searchPlaceholder': 'Caută mesaje...',
    'messages.tabs.all': 'Toate',
    'messages.tabs.unread': 'Necitite',
    'messages.tabs.announcements': 'Anunțuri',
    'messages.tabs.conversations': 'Conversații',
    'messages.tabs.following': 'Urmăriți',
    'messages.tabs.blocked': 'Blocate',
    'messages.loading': 'Se încarcă mesajele...',
    'messages.empty': 'Niciun mesaj',
    'messages.emptySearch': 'Niciun mesaj nu corespunde căutării dvs.',
    'messages.emptyUnread': 'Niciun mesaj necitit',
    'messages.emptyAnnouncements': 'Niciun anunț încă',
    'messages.emptyConversations': 'Nicio conversație încă',
    'messages.emptyDefault': 'Niciun mesaj încă',
    'messages.announcement': 'Anunț',
    'messages.conversation': 'Conversație',
    'messages.new': 'Nou',
    'messages.toast.allRead': 'Toate mesajele marcate ca citite',
    'messages.toast.errorMarkingRead': 'Nu s-au putut marca toate mesajele ca citite',
  },
  sr: {
    'messages.backToMessages': 'Назад на поруке',
    'messages.markAsRead': 'Означи као прочитано',
    'messages.title': 'Поруке',
    'messages.count': '{count} порука',
    'messages.count_plural': '{count} порука',
    'messages.markAllRead': 'Означи све као прочитано',
    'messages.filter': 'Филтрирај',
    'messages.allMerchants': 'Сви трговци',
    'messages.showUnread': 'Прикажи само непрочитане',
    'messages.searchPlaceholder': 'Претражи поруке...',
    'messages.tabs.all': 'Све',
    'messages.tabs.unread': 'Непрочитане',
    'messages.tabs.announcements': 'Објаве',
    'messages.tabs.conversations': 'Разговори',
    'messages.tabs.following': 'Пратим',
    'messages.tabs.blocked': 'Блокирани',
    'messages.loading': 'Учитавање порука...',
    'messages.empty': 'Нема порука',
    'messages.emptySearch': 'Нема порука које одговарају вашој претрази',
    'messages.emptyUnread': 'Нема непрочитаних порука',
    'messages.emptyAnnouncements': 'Још нема објава',
    'messages.emptyConversations': 'Још нема разговора',
    'messages.emptyDefault': 'Још нема порука',
    'messages.announcement': 'Објава',
    'messages.conversation': 'Разговор',
    'messages.new': 'Ново',
    'messages.toast.allRead': 'Све поруке означене као прочитане',
    'messages.toast.errorMarkingRead': 'Није успело означавање свих порука као прочитаних',
  },
  pl: {
    'messages.backToMessages': 'Powrót do Wiadomości',
    'messages.markAsRead': 'Oznacz jako Przeczytane',
    'messages.title': 'Wiadomości',
    'messages.count': '{count} wiadomość',
    'messages.count_plural': '{count} wiadomości',
    'messages.markAllRead': 'Oznacz Wszystkie jako Przeczytane',
    'messages.filter': 'Filtruj',
    'messages.allMerchants': 'Wszyscy Sprzedawcy',
    'messages.showUnread': 'Pokaż Tylko Nieprzeczytane',
    'messages.searchPlaceholder': 'Szukaj wiadomości...',
    'messages.tabs.all': 'Wszystkie',
    'messages.tabs.unread': 'Nieprzeczytane',
    'messages.tabs.announcements': 'Ogłoszenia',
    'messages.tabs.conversations': 'Rozmowy',
    'messages.tabs.following': 'Obserwowani',
    'messages.tabs.blocked': 'Zablokowani',
    'messages.loading': 'Ładowanie wiadomości...',
    'messages.empty': 'Brak wiadomości',
    'messages.emptySearch': 'Żadne wiadomości nie pasują do Twojego wyszukiwania',
    'messages.emptyUnread': 'Brak nieprzeczytanych wiadomości',
    'messages.emptyAnnouncements': 'Brak jeszcze ogłoszeń',
    'messages.emptyConversations': 'Brak jeszcze rozmów',
    'messages.emptyDefault': 'Brak jeszcze wiadomości',
    'messages.announcement': 'Ogłoszenie',
    'messages.conversation': 'Rozmowa',
    'messages.new': 'Nowe',
    'messages.toast.allRead': 'Wszystkie wiadomości oznaczone jako przeczytane',
    'messages.toast.errorMarkingRead': 'Nie udało się oznaczyć wszystkich wiadomości jako przeczytane',
  },
};
